export enum ExternalThawInternalAction {
  SET_STATE,
  SET_DEST_SELECTION_PROCESS,
  SET_RANDOMIZE_WELLS,
  SET_SELECTED_SOURCE_WELLS,
  SET_SELECTED_INTERMEDIATE_WELLS,
  SET_SELECTED_INT1_WELLS,
  SET_HOVER_WELL_ID,
  SET_NEXT_STEP,
  SET_PREV_STEP,
  SET_SELECTED_DESTINATION_INDEX,
  SET_REQUIRED_WARNINGS,
  SET_OPTIONAL_WARNINGS,
  SET_WORKLIST,
  SET_WORKLIST_PREVIEW_OPEN,
  UPDATE_METHOD_SETTINGS,
  UPDATE_STAMP_ROWCOLVOL,
  UPDATE_METHOD_SETTINGS_BY_TEMPLATE,
  SET_SEEDING_STRATEGY,
  SET_SPLIT_SEEDING_VOL_EVENLY,
  SET_PLATE_HAS_TUBE_BARCODE_SCAN,
  SET_INCUBATION_TIME,
  SET_EXPERIMENT_SETTINGS,
}

export interface IExternalThawInternalAction {
  payload: any;
  type: ExternalThawInternalAction;
}
